import { render, staticRenderFns } from "./ConsultaInventarioModal.vue?vue&type=template&id=51bbc603"
import script from "./ConsultaInventarioModal.vue?vue&type=script&lang=js"
export * from "./ConsultaInventarioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports